import React from 'react';
import { ShieldCheckIcon, LockIcon, HeartPulseIcon, BuildingIcon } from 'lucide-react';
export const TrustIndicators = () => {
  return <section className="w-full py-16 md:py-24 px-6 md:px-12 bg-gray-50 dark:bg-gray-800" data-id="element-201">
      <div className="max-w-6xl mx-auto" data-id="element-202">
        <div className="text-center mb-16" data-id="element-203">
          <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-204">
            Trusted by Healthcare Providers
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto" data-id="element-205">
            RootHealth is built with security and compliance at its core
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8" data-id="element-206">
          <div className="bg-white dark:bg-gray-900 p-6 rounded-lg shadow-sm flex flex-col items-center text-center" data-id="element-207">
            <ShieldCheckIcon size={32} className="text-green-600 dark:text-green-400 mb-4" data-id="element-208" />
            <h3 className="text-lg font-semibold mb-2" data-id="element-209">HIPAA-aligned</h3>
            <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-210">
              Built with least-privilege access and a BAA in a production
              environment
            </p>
          </div>
          <div className="bg-white dark:bg-gray-900 p-6 rounded-lg shadow-sm flex flex-col items-center text-center" data-id="element-211">
            <LockIcon size={32} className="text-green-600 dark:text-green-400 mb-4" data-id="element-212" />
            <h3 className="text-lg font-semibold mb-2" data-id="element-213">SOC 2 Ready</h3>
            <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-214">
              Controls and audit trail on the path to SOC 2 Type I
            </p>
          </div>
          <div className="bg-white dark:bg-gray-900 p-6 rounded-lg shadow-sm flex flex-col items-center text-center" data-id="element-215">
            <HeartPulseIcon size={32} className="text-green-600 dark:text-green-400 mb-4" data-id="element-216" />
            <h3 className="text-lg font-semibold mb-2" data-id="element-217">Healthcare-focused</h3>
            <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-218">
              Purpose-built for pricing data and CMS schema
            </p>
          </div>
          <div className="bg-white dark:bg-gray-900 p-6 rounded-lg shadow-sm flex flex-col items-center text-center" data-id="element-219">
            <BuildingIcon size={32} className="text-green-600 dark:text-green-400 mb-4" data-id="element-220" />
            <h3 className="text-lg font-semibold mb-2" data-id="element-221">Built for Hospitals</h3>
            <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-222">
              Designed to meet the unique needs of healthcare facilities
            </p>
          </div>
        </div>
      </div>
    </section>;
};